import React from 'react';
import { useTranslation } from 'react-i18next';

import { ChatView } from '@lemoncloud/ssocio-chatbots-api';

import { ChatHeader } from './ChatHeader';
import { ChatInput } from './ChatInput';
import { ChatMessages } from './ChatMessages';

interface ChatViewWithError extends ChatView {
    isError?: boolean;
}

interface DocumentData {
    id: string;
    title: string;
    content: string;
    name?: string;
}

export interface ChatInterfaceProps {
    agentName: string;
    messages: ChatViewWithError[];
    input: string;
    setInput: (value: string) => void;
    onSubmit: () => void;
    isWaitingResponse: boolean;
    isLoading?: boolean;
    currentChat?: any;
    onDocumentSelect?: (documentId: string) => Promise<DocumentData | null>;
    onEdit?: () => void;
    onHistory?: () => void;
    onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
    isLoadingMore?: boolean;
    hasMore?: boolean;
    showEditActions?: boolean;
    showHeader?: boolean;
}

export const ChatInterface: React.FC<ChatInterfaceProps> = ({
    agentName,
    messages,
    input,
    setInput,
    onSubmit,
    isWaitingResponse,
    isLoading = false,
    currentChat,
    onDocumentSelect,
    onEdit,
    onHistory,
    onScroll,
    isLoadingMore = false,
    hasMore = false,
    showEditActions = true,
    showHeader = true,
}) => {
    const { t } = useTranslation();

    return (
        <div className="flex-1 h-full bg-white dark:bg-[#1C1C1D] border border-chatbot-line rounded-[16px] overflow-hidden flex flex-col shadow-sm">
            {showHeader && (
                <ChatHeader
                    agentName={agentName}
                    onEdit={onEdit}
                    onHistory={onHistory}
                    showEditActions={showEditActions}
                />
            )}
            <ChatMessages
                messages={messages}
                isWaitingResponse={isWaitingResponse}
                isLoading={isLoading}
                hasInitialized={!!currentChat}
                onDocumentSelect={onDocumentSelect}
                onScroll={onScroll}
                isLoadingMore={isLoadingMore}
                hasMore={hasMore}
                emptyText={
                    <>
                        {t('agent.catalog.chat.emptyState.title', '채팅을 시작해보세요')}
                        <br />
                        {t('agent.catalog.chat.emptyState.description', 'AI 어시스턴트와 대화를 나누어보세요')}
                    </>
                }
            />
            <ChatInput input={input} setInput={setInput} onSubmit={onSubmit} isWaitingResponse={isWaitingResponse} />
        </div>
    );
};
